"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("path", {
        id: "prefix__a",
        d: "M10.522 4.737c-.717 0-1.334.522-1.475 1.246-.14.724.236 1.45.898 1.733a1.003 1.003 0 01-.928.635H7.01c-.353.002-.7.102-1.003.29V5.675c.691-.251 1.106-.979.982-1.722-.124-.744-.75-1.287-1.484-1.287-.733 0-1.36.543-1.483 1.287-.124.743.29 1.47.982 1.722v4.317c-.683.253-1.093.97-.977 1.706.117.737.726 1.283 1.451 1.3.725.018 1.359-.5 1.508-1.23a1.558 1.558 0 00-.899-1.75c.156-.384.52-.634.923-.635h2.007c.946 0 1.763-.68 1.962-1.632.692-.242 1.116-.961 1.003-1.705-.113-.744-.728-1.297-1.46-1.31zM5.505 3.704c.277 0 .502.23.502.516 0 .285-.225.517-.502.517s-.501-.232-.501-.517c0-.285.224-.516.501-.516zm0 8.262a.509.509 0 01-.501-.517c0-.285.224-.516.501-.516s.502.231.502.516a.51.51 0 01-.502.517zm5.017-5.164a.508.508 0 01-.501-.516c0-.286.224-.517.501-.517s.502.231.502.517a.51.51 0 01-.502.516z"
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      transform: "translate(.899)",
      fill: "none",
      fillRule: "evenodd",
      children: [(0, _jsxRuntime.jsx)("mask", {
        id: "prefix__b",
        fill: "currentColor",
        children: (0, _jsxRuntime.jsx)("use", {
          xlinkHref: "#prefix__a"
        })
      }), (0, _jsxRuntime.jsx)("use", {
        fill: "currentColor",
        fillRule: "nonzero",
        xlinkHref: "#prefix__a"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "currentColor",
        d: "M0 0h16v16H0z",
        mask: "url(#prefix__b)"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Merge.js.map